<script setup>
// Constants declarations
const attrs = useAttrs()
const { locale, t, d } = useI18n({ useScope: 'global' })

// Component props
const props = defineProps({
  listItems: {
    type: undefined,
    required: true,
    default: undefined,
  },
  dates: {
    type: Boolean,
    required: false,
    default: false,
  },
  dateFormat: {
    type: String,
    required: false,
    default: 'long',
  },
  isObject: {
    type: Boolean,
    required: false,
    default: false,
  },
  noData: {
    type: String,
    required: false,
    default: null,
  },
  numbered: {
    type: Boolean,
    required: false,
    default: false,
  },
  bullets: {
    type: Boolean,
    required: false,
    default: false,
  },
  regional: {
    type: String,
    required: false,
    default: undefined,
  },
  noPadding: {
    type: Boolean,
    required: false,
    default: false,
  },
})

// Refs

// Computed properties
const regionalSettings = computed(() => {
  return props.regional ? props.regional : locale.value
})

const items = computed(() => {
  return Array.isArray(props.listItems) || props.isObject
    ? Array.isArray(props.listItems)
      ? props.listItems.filter((item) => {
          if (item) {
            return item
          }
        })
      : props.listItems
    : [props.listItems].filter((item) => {
        if (item) {
          return item
        }
      })
})
</script>

<template>
  <q-list v-if="!isObject && items.length > 0" dense v-bind="$attrs" :class="{ 'q-px-none denser-list': noPadding }">
    <q-item v-for="(item, index) of items" :key="index" :class="{ 'numbered-list': numbered || bullets }">
      <q-item-section>
        <div class="row">
          <div class="col-auto" v-if="(numbered || bullets) && items.length > 1">
            <span v-if="bullets" class="q-mr-sm font-size-rem-9">&#x2022;</span>
            <span v-else>{{ index + 1 }}</span>
          </div>
          <div class="col" :class="numbered ? 'q-px-xs' : ''">
            <span v-if="dates && typeof item === 'string'">
              {{ d(item, dateFormat, regionalSettings) }}
            </span>
            <span v-else>
              {{ item }}
            </span>
          </div>
        </div>
      </q-item-section>
      <!--      <q-item-section v-if="numbered" side class="non-selectable">-->
      <!--        {{ index + 1 }}-->
      <!--      </q-item-section>-->
      <!--      <q-item-section>-->
      <!--        <q-item-label v-if="dates && typeof item === 'string'">-->
      <!--          {{ d(item, dateFormat, regionalSettings) }}-->
      <!--        </q-item-label>-->
      <!--        <q-item-label v-else>-->
      <!--          {{ item }}-->
      <!--        </q-item-label>-->
      <!--      </q-item-section>-->
    </q-item>
  </q-list>
  <q-list v-else-if="isObject" dense v-bind="$attrs">
    <q-item v-for="(value, key, index) in items" :key="key" :class="{ 'q-py-none': numbered }">
      <q-item-section v-if="numbered" side class="non-selectable">
        {{ index + 1 }}
      </q-item-section>
      <q-item-section :class="numbered ? 'q-px-sm' : ''">
        <q-item-label v-if="dates && typeof value === 'string'"> {{ key }}: {{ d(value, dateFormat, regionalSettings) }} </q-item-label>
        <div v-else>
          <q-item-label>{{ key }}: {{ value }}</q-item-label>
        </div>
      </q-item-section>
    </q-item>
  </q-list>
  <q-list v-else dense v-bind="$attrs">
    <q-item>
      <q-item-section v-if="noData">
        {{ noData }}
      </q-item-section>
      <q-item-section v-else> &nbsp;</q-item-section>
    </q-item>
  </q-list>
</template>

<style scoped></style>
